import { awsApiInstance } from '../api/aws-api';
import axios, { AxiosError } from 'axios';
import { showToast } from '../components/toasts';
import useAuth from '../hooks/auth-hooks';

import { ITerminalId, TerminalData } from '../models/terminal.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts an updated list of linked terminals to an individual card group
 * 
 * @param {ITerminalId} terminal the terminal/card group data
 * 
 * @returns api response
 */
const PostCardGroupTerminal = async ( terminal: ITerminalId ): Promise<any> => {
  try {
    const { userId } = useAuth()!; 

    const modelData = {
      wpID: userId,
      cardGroupId: terminal.cardGroups,
      terminalArray: terminal.terminalID
    };

    const { data } = await awsApiInstance.post(`/card-group/${terminal.cardGroups}/terminal`, modelData);

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error updating terminal card group data');
    throw(error);
  }
}

export default PostCardGroupTerminal;
